<template>
    <div class="tiers" v-view.once="initTiers" :class="stateObj">
            <div class="tiers_options">
                <div class="tiers__col tiers__col--fade-in">
                    <div class="tiers__el">
                        <div class="tiers__label tiers__padding"><b>{{ $t("message.tiers.t1.label") }}</b></div>
                        <div class="tiers__content">
                            <div class="tiers__price">
                                <a href="javascript:void(0)" v-scroll-to="'#calc'" @click.stop="tierClick($t('message.tiers.t1.label'))">
                                    <span class="tiers__price--amount">{{$t("message.currencySymbol")}}{{$t("message.tiers.t1.cost")}}<span class="tiers__price--currency">{{$t("message.currencyDesc")}}</span></span>
                                    <span class="tiers__price--label">{{$t("message.tiers.terms")}}</span>
                                </a>
                            </div>
                           
                        </div>
                        <div class="tiers__desc" v-html="$t('message.tiers.t1.desc')"></div>
                    </div>
                </div>
                <div class="tiers__col tiers__col--fade-in">
                    <div class="tiers__el">
                        <div class="tiers__label"><b>{{ $t("message.tiers.t2.label") }}</b></div>
                        <div class="tiers__content">
                            <div class="tiers__price">
                                <a href="javascript:void(0)" v-scroll-to="'#calc'" @click.stop="tierClick($t('message.tiers.t2.label'))">
                                    <span class="tiers__price--amount">{{$t("message.currencySymbol")}}{{$t("message.tiers.t2.cost")}}<span class="tiers__price--currency">{{$t("message.currencyDesc")}}</span></span>
                                    <span class="tiers__price--label">{{$t("message.tiers.terms")}}</span>
                                </a>
                            </div>
                            
                        </div>
                        <div class="tiers__desc" v-html="$t('message.tiers.t2.desc')"></div>
                    </div>
                </div>
                <div class="tiers__col tiers__col--fade-in">
                    <div class="tiers__el">
                        <div class="tiers__label"><b>{{ $t("message.tiers.t3.label") }}</b></div>
                        <div class="tiers__content">
                            <div class="tiers__price">
                                <a href="javascript:void(0)" v-scroll-to="'#calc'" @click.stop="tierClick($t('message.tiers.t3.label'))">
                                    <span class="tiers__price--amount">{{$t("message.currencySymbol")}}{{$t("message.tiers.t3.cost")}}<span class="tiers__price--currency">{{$t("message.currencyDesc")}}</span></span>
                                    <span class="tiers__price--label">{{$t("message.tiers.terms")}}</span>
                                </a>
                            </div>
                          
                        </div>
                        <div class="tiers__desc" v-html="$t('message.tiers.t3.desc')"></div>
                    </div>
                </div>
            </div>
        <div class="tier__features">
            <div class="tier__features_panel">
                <p v-html="$t('message.features.disclaimer1')"></p>
            </div>
        </div>
    </div>

</template>

<script>

    import { bus } from '../../../citrix-workspace/src/bus'

    export default {
        name: 'tiers',
        data(){
            return{
                stateObj:{
                    init: false
                }
            }
        },
        methods: {
            initTiers(){
                this.stateObj.init = true
            },
            tierClick(tier){
                bus.$emit("tierClick", tier)
            }
        }
    }

</script>